import { HomeType } from "./mutation-type";
export var actions = {
    updateNav: function (_a) {
        var commit = _a.commit;
        var nav = [
            {
                id: 1,
                name: "22",
                icon: "sitemap"
            },
            {
                id: 3,
                name: "33",
                icon: "sitemap",
                children: [
                    {
                        id: 1,
                        name: "22"
                    },
                    {
                        id: 3,
                        name: "33",
                        icon: "sitemap",
                    },
                    {
                        id: 4,
                        name: "44",
                        children: [
                            {
                                id: 1,
                                name: "22"
                            },
                            {
                                id: 3,
                                name: "33",
                                icon: "sitemap",
                            },
                            {
                                id: 4,
                                name: "44",
                                icon: "sitemap",
                            },
                            {
                                id: 5,
                                name: "55"
                            },
                            {
                                id: 6,
                                name: "66"
                            }
                        ]
                    },
                    {
                        id: 5,
                        name: "55"
                    },
                    {
                        id: 6,
                        name: "66"
                    }
                ]
            },
            {
                id: 4,
                name: "44",
                icon: "sitemap",
            },
            {
                id: 5,
                name: "55",
                icon: "sitemap",
            },
            {
                id: 6,
                name: "66",
                icon: "sitemap",
            }
        ];
        setHidden(nav);
        commit(HomeType.UPDATE_NAV, nav);
        function setHidden(nav) {
            nav.forEach(function (item) {
                item.childShow = false;
                item.onlyMenu = false;
                if (item.children) {
                    setHidden(item.children);
                    item.children.forEach(function (model) {
                        model.parent = item;
                    });
                }
            });
        }
    },
    controlNav: function (_a) {
        var commit = _a.commit, state = _a.state;
        commit(HomeType.CHANGE_NAV_STATUS);
    }
};
export default actions;
